import { computed, observable } from 'mobx';
import BaseStore from './BaseStore';

export default class AddressStore extends BaseStore {

    /*
    * 省
    * */
    @observable public iosProvinces: object[] = [];

    /*
    * 市
    * */
    @observable public iosCitys: object[] = [];

    /*
    * 区
    * */
    @observable public iosCountys: object[] = [];

    @computed
    get iosProvincesData(): any[] {
        return this.iosProvinces.slice()
    }

    @computed
    get iosCitysData(): any[] {
        return this.iosCitys.slice()
    }

    @computed
    get iosCountysData(): any[] {
        return this.iosCountys.slice()
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/store/AddressStore.ts